module.exports = __webpack_public_path__ + "static/media/bloom31.7b266dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blooming/bloom31.jpg
// module id = 647
// module chunks = 0